import { Modal as BootstrapModal, Button } from "react-bootstrap";
import "./Modal.css";

type ModalTypes = {
  enableModal: boolean;
  handleClose: () => void;
  handleSubmit?: any;
  title: string;
  closeButtonText: string;
  actionButtonText?: string;
  width?: string;
  children: any;
  buttonType?: "button" | "reset" | "submit";
  form?: string;
  disableActionButton?: boolean;
};

export const Modal = ({
  enableModal,
  handleClose,
  handleSubmit,
  title = "",
  closeButtonText = "Close",
  actionButtonText,
  children,
  width = "",
  buttonType,
  form,
  disableActionButton = false,
}: ModalTypes) => {
  return (
    <>
      <BootstrapModal
        show={enableModal}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        dialogClassName={width}
      >
        <BootstrapModal.Header closeButton>
          <BootstrapModal.Title>{title}</BootstrapModal.Title>
        </BootstrapModal.Header>
        <BootstrapModal.Body>{children}</BootstrapModal.Body>
        <BootstrapModal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            {closeButtonText}
          </Button>
          {form ? (
            <Button variant="danger" type={buttonType} form={form}>
              {actionButtonText}
            </Button>
          ) : (
            actionButtonText && (
              <Button
                variant="danger"
                onClick={handleSubmit}
                disabled={disableActionButton}
              >
                {actionButtonText}
              </Button>
            )
          )}
        </BootstrapModal.Footer>
      </BootstrapModal>
    </>
  );
};
